export default "__VITE_ASSET__BWHsPPzz__"